import { key } from 'piqure';
import type { RulesRepository } from '@/rule/domain/RulesRepository.ts';

export const RULES_REPOSITORY = key<RulesRepository>('RulesRepository');
